export const styles = () => ({
  root: {
    padding: 0,
    margin: 0,
  },
  page: {
    height: '270mm',
    margin: '13mm 0 0',
    'page-break-before': 'always',
  },
  content: {
    height: '245mm',
    overflow: 'hidden',
  },
});

export default styles;
